// använt https://github.com/Marwelln/Holiday/blob/master/src/Holiday.php för inspiration
export default (o, c, d) => {
  // true för högtidsdagar och röda dagar, inklusive intilligande helgdagar och fredagar
  c.prototype.isHoliday = function () {
    return isNewYearsWeekend(this) ||
      isEpiphanyWeekend(this) ||
      isEasterWeekend(this) ||
      isAscensionWeekend(this) ||
      isMayDayWeekend(this) ||
      isSwedishNationalDayWeekend(this) ||
      isMidsummerWeekend(this) ||
      isAllSaintsWeekend(this) ||
      isChristmas(this)
  }
}

// nyårsdagen: alltid 1 januari
// tar med olika perioder beroende på vilken veckodag den infaller
function isNewYearsWeekend (d) {
  let newYearsDay = null
  if (d.month() === 11) {
    // Om det är december så vill vi ha nyårsdag för nästa år för att se om dagen ingår i "nyårshelgen"
    newYearsDay = window.dayjs([d.year() + 1, 1, 1])
  } else {
    newYearsDay = window.dayjs([d.year(), 1, 1])
  }
  return isWeekendBasedOnVariableHoliday(d, newYearsDay)
}

// trettondag jul: alltid 6 januari
// tar med olika perioder beroende på vilken veckodag den infaller
function isEpiphanyWeekend (d) {
  const epiphanyDay = window.dayjs([d.year(), 1, 6])
  return isWeekendBasedOnVariableHoliday(d, epiphanyDay)
}

// påskdagen: första söndagen efter fullmånen som inträffar närmast 21 mars
// Tar med tors-mån
function isEasterWeekend (d) {
  const easterDay = gaussEaster(d.year())
  return d.isAfter(easterDay.subtract(4, 'days')) && d.isBefore(easterDay.add(2, 'days'))
}

// kristhimmelfärd: sjätte torsdagen efter påsk
// tar med ons-sön
function isAscensionWeekend (d) {
  const ascensionDay = gaussEaster(d.year()).add((4 + 5 * 7), 'days')
  return d.isAfter(ascensionDay.subtract(2, 'days')) && d.isBefore(ascensionDay.add(4, 'days'))
}

// första maj: alltid 1 maj
// tar med olika perioder beroende på vilken veckodag den infaller
function isMayDayWeekend (d) {
  const mayDay = window.dayjs([d.year(), 5, 1])
  return isWeekendBasedOnVariableHoliday(d, mayDay)
}

// svenska nationaldagen: alltid 6 juni
// tar med olika perioder beroende på vilken veckodag den infaller
function isSwedishNationalDayWeekend (d) {
  const swedishNationalDay = window.dayjs([d.year(), 6, 6])
  return isWeekendBasedOnVariableHoliday(d, swedishNationalDay)
}

// midsommardagen: lördagen mellan 20 och 26 juni
// tar med tors-sön
function isMidsummerWeekend (d) {
  const midsummerDay = getMidsummerDay(d.year())
  return d.isAfter(midsummerDay.subtract(3, 'days')) && d.isBefore(midsummerDay.add(2, 'days'))
}

// alla helgons dag: lördagen mellan 31 oktober och 7 november
// tar med fre - sön (osäker på om vi ska visa denna eftersom det inte är några extra dagar, men är ju en rätt känd högtid i alla fall)
function isAllSaintsWeekend (d) {
  const allSaintsDay = getAllSaintsDay(d.year())
  return d.isAfter(allSaintsDay.subtract(2, 'days')) && d.isBefore(allSaintsDay.add(2, 'days'))
}

// juldagen: alltid 25 december
// tar med 23 till 26 december
function isChristmas (d) {
  const christmasDay = window.dayjs([d.year(), 12, 25])
  return d.isAfter(christmasDay.subtract(3, 'days')) && d.isBefore(christmasDay.add(2, 'days'))
}

// för högtider med en dag ledigt som kan infalla på olika veckodagar, beräknar vilka dagar vi vill visa som "högtid" i kalendern baserat på klämdagar och helgdagar
function isWeekendBasedOnVariableHoliday (d, holiday) {
  let daysBefore = 0
  let daysAfter = 0
  if (holiday.day() === 4) {
    // torsdag - klämdag på fredag så tar med ons-sön
    daysBefore = 1
    daysAfter = 3
  } else if (holiday.day() === 5) {
    // fredag - tar med tors-sön
    daysBefore = 1
    daysAfter = 2
  } else if (holiday.day() === 6) {
    // lördag - bara fre-sön
    daysBefore = 1
    daysAfter = 1
  } else if (holiday.day() === 1) {
    // måndag - tar med fre-mån
    daysBefore = 3
    daysAfter = 0
  } else {
    // sön, tis eller ons - tar med nationaldagen och dagen innan
    daysBefore = 1
    daysAfter = 0
  }
  return d.isAfter(holiday.subtract(daysBefore + 1, 'days')) && d.isBefore(holiday.add(daysAfter + 1, 'days'))
}

// Beräknar Alla Helgons Dag. lördagen mellan 31 oktober och 7 november
function getAllSaintsDay (y) {
  let dt = window.dayjs([y, 10, 31])
  for (let i = 0; i <= 6; ++i) {
    dt = dt.add(1, 'days')
    if (dt.day() === 6) { // 6 = lördag (0  = söndag)
      return dt
    }
  }
}

// Beräknar Midsommardagen. lördagen mellan 20 och 26 juni
function getMidsummerDay (y) {
  let dt = window.dayjs([y, 6, 20])
  for (let i = 0; i <= 6; ++i) {
    dt = dt.add(1, 'days')
    if (dt.day() === 6) { // 6 = lördag (0  = söndag)
      return dt
    }
  }
}

// Beräknar Påskdagen
function gaussEaster (Y) {
  // algoritm från https://www.geeksforgeeks.org/how-to-calculate-the-easter-date-for-a-given-year-using-gauss-algorithm/
  // All calculations done on the basis of Gauss Easter Algorithm
  const A = Y % 19
  const B = Y % 4
  const C = Y % 7
  const P = Math.floor(Y / 100.0)
  const Q = Math.floor((13 + 8 * P) / 25.0)
  const M = Math.floor(15 - Q + P - Math.floor(P / 4)) % 30
  const N = Math.floor(4 + P - Math.floor(P / 4)) % 7
  const D = Math.floor(19 * A + M) % 30
  const E = Math.floor(2 * B + 4 * C + 6 * D + N) % 7

  const days = Math.floor(22 + D + E)

  if ((D === 29) && (E === 6)) {
    // A corner case,
    // when D is 29
    return window.dayjs([Y, 4, 19]) // 19 april
  } else if ((D === 28) && (E === 6)) {
    // Another corner case,
    // when D is 28
    return window.dayjs([Y, 4, 18]) // 18 april
  } else {
    if (days > 31) {
      // If days > 31, move to April
      return window.dayjs([Y, 4, (days - 31)]) // april
    } else {
      // Otherwise, stay on March
      return window.dayjs([Y, 3, days]) // mars
    }
  }
}
